import React, { useEffect, useState } from 'react';
import { Smartphone, Share, Plus, Download } from 'lucide-react';

function isIos() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}
function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

export default function MarketingInstallCTA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [showIosHelp, setShowIosHelp] = useState(false);

  useEffect(() => {
    if (isStandalone()) { setInstalled(true); return; }
    const onBeforeInstall = (e) => { e.preventDefault(); setDeferredPrompt(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstall);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  if (installed) return null;

  const onClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
    } else {
      setShowIosHelp(true);
    }
  };

  return (
    <section className="mx-auto max-w-6xl px-5 pb-4">
      <div
        data-testid="marketing-install-cta"
        className="flex flex-col items-start gap-4 rounded-2xl border border-border bg-white p-6 card-soft sm:flex-row sm:items-center sm:justify-between"
      >
        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-accent">
            <Smartphone className="h-6 w-6 text-[hsl(var(--coral))]" />
          </div>
          <div>
            <p className="font-extrabold">Install Purrflect on your phone</p>
            {showIosHelp ? (
              <p className="mt-0.5 text-sm text-muted-foreground">
                Tap <Share className="inline h-4 w-4 align-text-bottom" /> Share, then{' '}
                <Plus className="inline h-4 w-4 align-text-bottom" /> Add to Home Screen.
              </p>
            ) : (
              <p className="mt-0.5 text-sm text-muted-foreground">
                Add it to your home screen for one-tap access — no app store needed.
              </p>
            )}
          </div>
        </div>
        {!showIosHelp && (
          <button
            data-testid="marketing-install-btn"
            onClick={onClick}
            className="coral-btn inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-bold text-white"
          >
            <Download className="h-4 w-4" />
            {isIos() ? 'How to install' : 'Install app'}
          </button>
        )}
      </div>
    </section>
  );
}
